export const GET_NOTIFICATION_PREFERENCES = 'SETTINGS/GET_NOTIFICATION_PREFERENCES';
export const UPSERT_ALERT = 'SETTINGS/UPSERT_ALERT';
export const SET_ALERT_MEDIUM = 'SETTINGS/SET_ALERT_MEDIUM';
